import React, { useEffect } from "react"
import styled from "styled-components"
import Meta from "../utilities/seo"
import Footer from "../components/layout/footer"
import Header from "../components/layout/header"
import JiwekeSawaHeader from "../components/layout/jiweke-sawa-header"
import Planning from "../components/home/planning/container"
import Main from "../components/layout/main"
import Splash from "../components/home/splash/container"
import Saving from "../components/home/saving/container"
import Investment from "../components/home/investment/container"
import Process from "../components/home/process-updated/container"
import Support from "../components/home/support/container"

const Page = () => {
  const Box = styled.div`
  .desktop-view {
    display: block;
  }
  .mobile-view {
     display: none;
  }

  @media (max-width: 766px) {
  .desktop-view {
    display: none;
  }
  .mobile-view {
     display: block;
  }
  }
  `
  return (
    <>
      <Meta
        image={{
          url: "https://res.cloudinary.com/xeno-technologies/image/upload/a_hflip/v1633502840/shutterstock_1750668944_qaeh93.jpg",
          height: "1280",
          width: "853",
        }}
      />
      <Main>
        <Box>
          <div className="mobile-view">
            <JiwekeSawaHeader />
          </div>
          <div className="desktop-view">
            <Header />
          </div>
        </Box>
        <Splash />
        <Investment />
        <Planning />
        <Saving />
        <Process />
        <Support />
        <Footer />
      </Main>
    </>
  )
}
export default Page
